import { Lottie } from 'lottie-react';
import animationData from '../assets/sosello-logo-animation.json';

export default function SplashScreen() {
  return (
    <div className="app-loading" role="status" aria-label="Loading Sosello">
      <div className="app-splash">
        <Lottie
          src={animationData}
          loop={false}
          autoplay
          className="app-splash-lottie"
        />
      </div>
    </div>
  );
}
